import axios from "axios";
import { getToken, clearSession } from "./auth";

const envBase = process.env.REACT_APP_API_BASE_URL;
const baseURL = envBase && envBase.trim()
  ? envBase.trim()
  : `${window.location.protocol}//${window.location.hostname}:5000/api`;

const api = axios.create({
  baseURL,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  // Cache-bust GET requests so freshly-saved rows show up without a page reload.
  if ((config.method || "get").toLowerCase() === "get") {
    config.params = { ...(config.params || {}), _t: Date.now() };
    config.headers = { ...(config.headers || {}), "Cache-Control": "no-cache" };
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      clearSession();
      if (window.location.pathname !== "/" && window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export default api;
